import React from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, withRouter } from 'react-router-dom';
import {Alert} from '@betareader/design-system';
import fire from '../../config/fire';

export const RestrictedBookRoute = ({
  component: Component,
  isAuthenticated,
  currentBook,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthenticated) {
        // no book loaded yet. wait until it is.
        if (!currentBook) {
          return <div className='br-app-loading' role='status'>
            <span className='br-app-loading__spinner' aria-hidden='true' />
            Loading book…
          </div>;
        }
        // a book is loaded
        if (!['author', 'collaborator'].includes(currentBook.role)) {
          // the user is not the author or a collaborator
          return <Alert variant='warning'>Forbidden</Alert>;
        }
        // the user must be the author or a collaborator
        return <Component {...props} />;
      }
      // not authenticated. redirect to signin
      return (
        <Redirect
          to={{
            pathname: '/signin',
            search: `redirect=${encodeURIComponent(
              window.location.pathname + window.location.search
            )}`,
          }}
        />
      );
    }}
  />
);

function mapStateToProps(state) {
  return {
    isAuthenticated:
      (!!fire.auth().currentUser && !fire.auth().currentUser.isAnonymous) ||
      (!!localStorage.getItem('br-storage-key') &&
        !localStorage.getItem('br-is-anonymous')),
    idToken: localStorage.getItem('br-storage-key'),
    location: state.location,
    currentBook: state.book.currentBook,
  };
}

export default withRouter(connect(mapStateToProps, null)(RestrictedBookRoute));
